import cookie from 'react-cookies';
import {base64Encode, base64Des, md5String} from './commonSecret';
import {Component} from "react";


class cookieUtil extends Component {

    static cookiesDomain = ".91y.com";

    static has(key) {
        return !!cookie.load(md5String(key));
    }

    static get(key) {
        return base64Des(cookie.load(md5String(key)));
    }

    static put(key, value) {
        cookie.save(md5String(key), base64Encode(value), {path: "/", domain: this.cookiesDomain});
    }

    static putExpire(key, value) {
        let expires = new Date(new Date().getTime() + 60 * 60 * 1000)
        cookie.save(md5String(key), base64Encode(value), {path: "/", expires, domain: this.cookiesDomain});

    }

    static remove(key) {
        cookie.remove(md5String(key), {path: "/", domain: this.cookiesDomain})
    }

}

export default cookieUtil;
